import React, { useState } from "react";
import DeleteConfirmationDialog from "../../Investors/InvestorDetails/InvestorProjectDetails/InvestorProjectDetailDistributions/DeleteConfirmModal";
import { IconButton } from "@mui/material";
import { DeleteForever } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  deleteCurrentInvestment,
  getInvestmentsList,
} from "../../../../actions/investmentsActions";

function InvestmentRemove(props) {
  const params = useParams();
  const dispatch = useDispatch();

  const [deleteOpen, setDeleOpen] = useState(false);

  const handleDeleteClose = () => {
    setDeleOpen(false);
  };
  const handleDelete = () => {
    console.log({ props });
    dispatch(
      deleteCurrentInvestment({
        id: props.investment._id,
        callback: () => {
          handleDeleteClose();
          dispatch(
            getInvestmentsList({
              query: { projectRef: params.id, results: 999999 },
            })
          );
        },
      })
    );
  };
  return (
    <div>
      <DeleteConfirmationDialog
        open={deleteOpen}
        title={"Deseas borrar Inversionista del proyecto"}
        message={"Esta acción es permanente, ¿estas seguro de continuar?"}
        onClose={handleDeleteClose}
        onConfirm={handleDelete}
      />
      <IconButton
        onClick={() => {
          setDeleOpen(true);
        }}
      >
        <DeleteForever></DeleteForever>
      </IconButton>
    </div>
  );
}

export default InvestmentRemove;
